
import { defineComponent } from 'vue';
import { ColorToneGenerator } from '@/color-tone-generator';
import ColorBox from '@/components/elements/color-box.vue';

export default defineComponent( {
  components: { ColorBox },
  data() {
    return {
      color: '#68a194',
      name: 'primary',
    };
  },
  methods: {
    colors(): { rgb: string, tone: number }[] {
      return ColorToneGenerator.createTones( this.color );
    },
    scss(): string {
      return ColorToneGenerator.generateScss( this.color, this.name );
    }
  }
} );
